export enum SecurityPermissionName {
  ACTIVATE_PRESENCE_PROFILE_MECHANISM = 'ACTIVATE_PRESENCE_PROFILE_MECHANISM',
  MANAGE_ACD_ADVANCED_SETTINGS = 'MANAGE_ACD_ADVANCED_SETTINGS',
  ASSIGN_ANY_MAIN_PHONE_NUMBER = 'ASSIGN_ANY_MAIN_PHONE_NUMBER',
  ASSIGN_DEVICE_TO_ANY_USER = 'ASSIGN_DEVICE_TO_ANY_USER',
  ASSIGN_DEVICE_TO_USER = 'ASSIGN_DEVICE_TO_USER',
  ASSIGN_EMERGENCY_AND_VISIBLE_NUMBER_TO_ANY_USER = 'ASSIGN_EMERGENCY_AND_VISIBLE_NUMBER_TO_ANY_USER',
  ASSIGN_EMERGENCY_AND_VISIBLE_NUMBER_TO_USER = 'ASSIGN_EMERGENCY_AND_VISIBLE_NUMBER_TO_USER',
  ASSIGN_INTERNAL_MAIN_PHONE_NUMBER = 'ASSIGN_INTERNAL_MAIN_PHONE_NUMBER',
  ASSIGN_MAIN_PHONE_NUMBER = 'ASSIGN_MAIN_PHONE_NUMBER',
  ASSIGN_USERS_TO_ROOM = 'ASSIGN_USERS_TO_ROOM',
  ASSIGN_ROUTING_GROUP = 'ASSIGN_ROUTING_GROUP',
  DEFINE_ANY_REACHABILITY = 'DEFINE_ANY_REACHABILITY',
  DEFINE_REACHABILITY = 'DEFINE_REACHABILITY',
  EDIT_ADMINS = 'EDIT_ADMINS',
  EDIT_FEATURE_SERVICENUMBER_SELECT = 'EDIT_FEATURE_SERVICENUMBER_SELECT',
  EDIT_LOCATION = 'EDIT_LOCATION',
  EDIT_LOCATION_GROUP_ORIGIN_CODE = 'EDIT_LOCATION_GROUP_ORIGIN_CODE',
  EDIT_ROUTING_GROUP = 'EDIT_ROUTING_GROUP',
  EDIT_SCREEN_NUMBER_DESCRIPTION = 'EDIT_SCREEN_NUMBER_DESCRIPTION',
  EDIT_SITE = 'EDIT_SITE',
  EDIT_TRUNKS = 'EDIT_TRUNKS',
  EDIT_TRUNK_ADVANCED_SETTINGS = 'EDIT_TRUNK_ADVANCED_SETTINGS',
  EDIT_TRUNK_CREDENTIALS = 'EDIT_TRUNK_CREDENTIALS',
  EDIT_TRUNK_ORIGIN_CODE = 'EDIT_TRUNK_ORIGIN_CODE',
  EDIT_TRUNK_PASSWORD = 'EDIT_TRUNK_PASSWORD',
  EDIT_USER = 'EDIT_USER',
  EDIT_USER_WITH_DEVICE_MASTER_DATA = 'EDIT_USER_WITH_DEVICE_MASTER_DATA',
  ENABLE_ENDUSER_SUSPEND_STATUS = 'ENABLE_ENDUSER_SUSPEND_STATUS',
  IMPORT_PHONEBOOK = 'IMPORT_PHONEBOOK',
  LIST_USERS = 'LIST_USERS',
  MAC_ADDRESSES_EXPORT_IMPORT = 'MAC_ADDRESSES_EXPORT_IMPORT',
  MANAGE_ADMIN_EMAIL_FOR_NOTIFICATIONS = 'MANAGE_ADMIN_EMAIL_FOR_NOTIFICATIONS',
  MANAGE_ADMINS = 'MANAGE_ADMINS',
  MANAGE_ADVANCED_USER_SETTINGS = 'MANAGE_ADVANCED_USER_SETTINGS',
  MANAGE_ALLOWED_DEVICES = 'MANAGE_ALLOWED_DEVICES',
  MANAGE_ANNOUNCEMENTS = 'MANAGE_ANNOUNCEMENTS',
  MANAGE_ANY_CONFERENCE = 'MANAGE_ANY_CONFERENCE',
  MANAGE_ANY_ENTERPRISE = 'MANAGE_ANY_ENTERPRISE',
  MANAGE_ANY_ENTERPRISE_ACL = 'MANAGE_ANY_ENTERPRISE_ACL',
  MANAGE_ANY_IVR = 'MANAGE_ANY_IVR',
  MANAGE_ANY_PHONEBOOK = 'MANAGE_ANY_PHONEBOOK',
  MANAGE_ANY_REGISTRATIONS = 'MANAGE_ANY_REGISTRATIONS',
  MANAGE_ANY_USER_ACL = 'MANAGE_ANY_USER_ACL',
  MANAGE_ANY_USER_FEATURE_CONFIG = 'MANAGE_ANY_USER_FEATURE_CONFIG',
  MANAGE_ANY_USER_WITHOUT_DEVICE = 'MANAGE_ANY_USER_WITHOUT_DEVICE',
  MANAGE_ASSIGNED_DOWNLOADS = 'MANAGE_ASSIGNED_DOWNLOADS',
  MANAGE_CONFERENCE = 'MANAGE_CONFERENCE',
  MANAGE_CUSTOM_SCREEN_NUMBER = 'MANAGE_CUSTOM_SCREEN_NUMBER',
  MANAGE_DEVICES = 'MANAGE_DEVICES',
  MANAGE_ENTERPRISE = 'MANAGE_ENTERPRISE',
  MANAGE_ENTERPRISE_CLUSTER_PARTITION = 'MANAGE_ENTERPRISE_CLUSTER_PARTITION',
  MANAGE_ENTERPRISE_OPTIONS = 'MANAGE_ENTERPRISE_OPTIONS',
  MANAGE_ENTERPRISE_ACL = 'MANAGE_ENTERPRISE_ACL',
  MANAGE_GENERIC_DEVICE = 'MANAGE_GENERIC_DEVICE',
  MANAGE_IPFILTER = 'MANAGE_IPFILTER',
  MANAGE_IVR = 'MANAGE_IVR',
  MANAGE_LOCATIONS = 'MANAGE_LOCATIONS',
  MANAGE_NOTIFICATIONS = 'MANAGE_NOTIFICATIONS',
  MANAGE_PHONEBOOK = 'MANAGE_PHONEBOOK',
  MANAGE_PRESENCE_PROFILE = 'MANAGE_PRESENCE_PROFILE',
  MANAGE_PRODUCT_OPTION = 'MANAGE_PRODUCT_OPTION',
  MANAGE_REGISTRATIONS = 'MANAGE_REGISTRATIONS',
  MANAGE_CLIENT_LOGGING_CONFIG = 'MANAGE_CLIENT_LOGGING_CONFIG',
  MANAGE_ROOMS = 'MANAGE_ROOMS',
  MANAGE_ROUTING_GROUP = 'MANAGE_ROUTING_GROUP',
  MANAGE_ROUTING_NTS = 'MANAGE_ROUTING_NTS',
  MANAGE_SCREEN_NUMBER = 'MANAGE_SCREEN_NUMBER',
  MANAGE_SERVICE_SCREEN_NUMBER = 'MANAGE_SERVICE_SCREEN_NUMBER',
  MANAGE_SITE_SERVICES = 'MANAGE_SITE_SERVICES',
  MANAGE_SITE_SERVICE_NUMBERS = 'MANAGE_SITE_SERVICE_NUMBERS',
  MANAGE_SITES = 'MANAGE_SITES',
  MANAGE_SMS_NOTIFICATIONS = 'MANAGE_SMS_NOTIFICATIONS',
  MANAGE_SYSTEM = 'MANAGE_SYSTEM',
  MANAGE_SYSTEM_ACL = 'MANAGE_SYSTEM_ACL',
  MANAGE_TRUNK_CUSTOM_NUMBER_RANGE = 'MANAGE_TRUNK_CUSTOM_NUMBER_RANGE',
  MANAGE_TRUNKS = 'MANAGE_TRUNKS',
  MANAGE_TEAMS_TRUNKS = 'MANAGE_TEAMS_TRUNKS',
  MANAGE_USER = 'MANAGE_USER',
  MANAGE_USER_ACL = 'MANAGE_USER_ACL',
  MANAGE_USER_CALL_LOG = 'MANAGE_USER_CALL_LOG',
  MANAGE_USER_FEATURE_CONFIG = 'MANAGE_USER_FEATURE_CONFIG',
  MANAGE_USER_OPTIONAL_FEATURES = 'MANAGE_USER_OPTIONAL_FEATURES',
  MANAGE_USER_PHONE_NUMS = 'MANAGE_USER_PHONE_NUMS',
  MANAGE_USER_WITH_AUTOMATIC_LICENSE_RECOVERY = 'MANAGE_USER_WITH_AUTOMATIC_LICENSE_RECOVERY',
  MANAGE_USER_WITH_DEVICE = 'MANAGE_USER_WITH_DEVICE',
  MANAGE_USER_WITHOUT_DEVICE = 'MANAGE_USER_WITHOUT_DEVICE',
  MODIFY_ANY_ROOM_SETTINGS = 'MODIFY_ANY_ROOM_SETTINGS',
  MODIFY_ANY_USER_UC_DATA = 'MODIFY_ANY_USER_UC_DATA',
  MODIFY_OWN_USER_UC_DATA = 'MODIFY_OWN_USER_UC_DATA',
  MODIFY_ROOM_SETTINGS = 'MODIFY_ROOM_SETTINGS',
  MODIFY_SINGLE_NUMBER_FOR_ANY_USER = 'MODIFY_SINGLE_NUMBER_FOR_ANY_USER',
  MODIFY_SINGLE_NUMBER_FOR_USER = 'MODIFY_SINGLE_NUMBER_FOR_USER',
  MODIFY_USER_UC_DATA = 'MODIFY_USER_UC_DATA',
  PLACEHOLDER_PERMISSION = 'PLACEHOLDER_PERMISSION',
  REMOVE_DEVICE_FROM_ANY_USER = 'REMOVE_DEVICE_FROM_ANY_USER',
  REMOVE_DEVICE_FROM_USER = 'REMOVE_DEVICE_FROM_USER',
  REPLACE_DEVICE_FOR_ANY_USER = 'REPLACE_DEVICE_FOR_ANY_USER',
  REPLACE_DEVICE_FOR_USER = 'REPLACE_DEVICE_FOR_USER',
  RESET_FEATURES_TO_USER_DEFAULTS = 'RESET_FEATURES_TO_USER_DEFAULTS',
  RESET_GENERIC_DEVICE_PASSWORD = 'RESET_GENERIC_DEVICE_PASSWORD',
  SCREEN_NUMBER_BULK_ACTION_ENDUSER = 'SCREEN_NUMBER_BULK_ACTION_ENDUSER',
  VIEW_ACD = 'VIEW_ACD',
  VIEW_ADMINS = 'VIEW_ADMINS',
  VIEW_ALLOWED_DEVICES = 'VIEW_ALLOWED_DEVICES',
  VIEW_ANNOUNCEMENTS = 'VIEW_ANNOUNCEMENTS',
  VIEW_ANY_CONFERENCE = 'VIEW_ANY_CONFERENCE',
  VIEW_ANY_ENTERPRISE = 'VIEW_ANY_ENTERPRISE',
  VIEW_ANY_ENTERPRISE_ACL = 'VIEW_ANY_ENTERPRISE_ACL',
  VIEW_ANY_IVR = 'VIEW_ANY_IVR',
  VIEW_ANY_JOURNAL = 'VIEW_ANY_JOURNAL',
  VIEW_ANY_PHONEBOOK = 'VIEW_ANY_PHONEBOOK',
  VIEW_ANY_REGISTRATIONS = 'VIEW_ANY_REGISTRATIONS',
  VIEW_ANY_SCREENNUMBER = 'VIEW_ANY_SCREENNUMBER',
  VIEW_ANY_SOFTKEY_CONFIG = 'VIEW_ANY_SOFTKEY_CONFIG',
  VIEW_ANY_USER_ACL = 'VIEW_ANY_USER_ACL',
  VIEW_ANY_USER_DATA = 'VIEW_ANY_USER_DATA',
  VIEW_ANY_USER_FEATURES = 'VIEW_ANY_USER_FEATURES',
  VIEW_CDR = 'VIEW_CDR',
  VIEW_CONFERENCE = 'VIEW_CONFERENCE',
  VIEW_DOCUMENTS = 'VIEW_DOCUMENTS',
  VIEW_DEVICES = 'VIEW_DEVICES',
  VIEW_ENTERPRISE = 'VIEW_ENTERPRISE',
  VIEW_ENTERPRISE_ACL = 'VIEW_ENTERPRISE_ACL',
  VIEW_ENTERPRISE_OPTIONS = 'VIEW_ENTERPRISE_OPTIONS',
  VIEW_IPFILTER = 'VIEW_IPFILTER',
  VIEW_IVR = 'VIEW_IVR',
  VIEW_JOURNAL = 'VIEW_JOURNAL',
  VIEW_LOCATIONS = 'VIEW_LOCATIONS',
  VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS',
  VIEW_PAGE_CALENDAR = 'VIEW_PAGE_CALENDAR',
  VIEW_PAGE_CALL_BARRING = 'VIEW_PAGE_CALL_BARRING',
  VIEW_PAGE_FEATURES = 'VIEW_PAGE_FEATURES',
  VIEW_PAGE_GATEWAYS = 'VIEW_PAGE_GATEWAYS',
  VIEW_PAGE_GENERAL = 'VIEW_PAGE_GENERAL',
  VIEW_PAGE_GROUPS = 'VIEW_PAGE_GROUPS',
  VIEW_PAGE_HOME = 'VIEW_PAGE_HOME',
  VIEW_PAGE_PHONE = 'VIEW_PAGE_PHONE',
  VIEW_PAGE_PHONEBOOK = 'VIEW_PAGE_PHONEBOOK',
  VIEW_PAGE_PHONES = 'VIEW_PAGE_PHONES',
  VIEW_PAGE_SETTINGS = 'VIEW_PAGE_SETTINGS',
  VIEW_PAGE_UNIFIED_BOX = 'VIEW_PAGE_UNIFIED_BOX',
  VIEW_PHONEBOOK = 'VIEW_PHONEBOOK',
  VIEW_PRESENCE_PROFILE = 'VIEW_PRESENCE_PROFILE',
  VIEW_PRODUCT_OPTION = 'VIEW_PRODUCT_OPTION',
  VIEW_REGISTRATIONS = 'VIEW_REGISTRATIONS',
  VIEW_CLIENT_LOGGING_CONFIG = 'VIEW_CLIENT_LOGGING_CONFIG',
  VIEW_ROOMS = 'VIEW_ROOMS',
  VIEW_ROUTING_GROUP = 'VIEW_ROUTING_GROUP',
  VIEW_ROUTING_NTS = 'VIEW_ROUTING_NTS',
  VIEW_SCREEN_NUMBER = 'VIEW_SCREEN_NUMBER',
  VIEW_SITES = 'VIEW_SITES',
  VIEW_SITE_SERVICES = 'VIEW_SITE_SERVICES',
  VIEW_SOFTKEY_CONFIG = 'VIEW_SOFTKEY_CONFIG',
  VIEW_SOFTCLIENTS = 'VIEW_SOFTCLIENTS',
  VIEW_TIMETABLES = 'VIEW_TIMETABLES',
  VIEW_TRUNKS = 'VIEW_TRUNKS',
  VIEW_TRUNK_ORIGIN_CODE = 'VIEW_TRUNK_ORIGIN_CODE',
  VIEW_TRUNK_PASSWORD = 'VIEW_TRUNK_PASSWORD',
  VIEW_USER = 'VIEW_USER',
  VIEW_USER_ACL = 'VIEW_USER_ACL',
  VIEW_USER_CALL_LOG = 'VIEW_USER_CALL_LOG',
  VIEW_USER_DATA = 'VIEW_USER_DATA',
  VIEW_USER_FEATURES = 'VIEW_USER_FEATURES',
  VIEW_USER_OPTIONAL_FEATURES = 'VIEW_USER_OPTIONAL_FEATURES',
  VIEW_SCREEN_NUMBER_ACTIVATION_STATUS = 'VIEW_SCREEN_NUMBER_ACTIVATION_STATUS',
  VIEW_MS365_PRESENCE = 'VIEW_MS365_PRESENCE',
  MANAGE_MS365_PRESENCE = 'MANAGE_MS365_PRESENCE',
  MANAGE_SCREEN_NUMBER_ACTIVATION_STATUS = 'MANAGE_SCREEN_NUMBER_ACTIVATION_STATUS',
  VIEW_CALLCENTER_AGENTS = 'VIEW_CALLCENTER_AGENTS',
  MANAGE_CALLCENTER_AGENTS = 'MANAGE_CALLCENTER_AGENTS',
  ACD_MASTER_AGENT_ADVANCED = 'ACD_MASTER_AGENT_ADVANCED',
  VIEW_SBC = 'VIEW_SBC',
  EDIT_ENTERPRISE_SBC = 'EDIT_ENTERPRISE_SBC',
  VIEW_DEVICE_SETTINGS = 'VIEW_DEVICE_SETTINGS',
  MANAGE_DEVICE_SETTINGS = 'MANAGE_DEVICE_SETTINGS',
}
